import * as types from "../ActionType";

const initState = {
    visitors: [],
    loadingVisitors: true
}

const VisitorReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_VISITOR:
            return { ...state, loadingVisitors: true }
        case types.GET_VISITORS:
            return { ...state, visitors: action.payload, loadingVisitors: false }
        case types.DELETE_VISITOR:
            return { ...state }
        case types.EDIT_VISITOR:
            return { ...state, loadingVisitors: true }
        case types.BLOCK_VISITOR:
            return { ...state, loadingVisitors: true }
        default:
            return state;
    }
};

export default VisitorReducer;
